<template>
    <div class="share" id="share">
        <div class="share-container" v-if="supported">
        <div class="share-picture">
            <video ref="video" autoplay playsinline v-show="!screenshot"></video>
            <img ref="overlay" src="@/assets/images/overlay.svg" v-show="!screenshot">
            <img ref="img" src="" v-show="screenshot">
            <canvas ref="canvas" width="640" height="640" style="display: none;"></canvas>
            <canvas ref="canvas2" width="640" height="640" style="display: none;"></canvas>
            <div class="share-user" v-show="!screenshot" id="capture">
                <h3 class="share-title h5">{{ $t('share.modal_text') }}</h3>
                <ul class="share-info">
                    <!-- <li v-if="user.rank">{{ user.rank }}
                        <span class="label">{{ $t('labels.overall_rank') }}</span>
                    </li> -->
                    <li>{{ user.completed.length }}<span class="lighten">/{{ storiesNbr }}</span>
                        <span class="label">{{ $t('labels.stories_completed') }}</span>
                    </li>
                    <li>{{ user.success }}<span class="lighten">%</span>
                        <span class="label">{{ $t('labels.success_rate') }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="share-content">
            <button
                :disabled="!html2canvas"
                @click="screenshot ? startCapture() : takeScreenshot()"
                class="btn-round large"
            >
                <sprite
                  :type="'camera'"
                  :width="33"
                  :height="27"
                />
                <span class="u-visually-hidden">{{ $t('share.modal_title') }}</span>
            </button>
             <btn
                :disabled="!(this.picture.length > 0) || !shareSupported"
                @click="share">
                {{ $t('share.modal_cta') }}
                <sprite
                  :type="'arrow-right'"
                  :width="19"
                  :height="12"
                />
            </btn>
            <p v-if="!shareSupported">{{ $t('share.not_supported') }}</p>
        </div>
        </div>
        <p class="share-message" v-else>{{ $t('share.not_supported') }}</p>
    </div>
</template>

<script>
import Btn from '@/components/components/Btn.vue';
import Sprite from '@/components/components/Sprite.vue';

export default {
  components: {
    Btn,
    Sprite
  },
  mounted() {
    this.startCapture();
  },
  data() {
    return {
      supported: navigator.mediaDevices && navigator.mediaDevices.getUserMedia,
      shareSupported: navigator.share && navigator.canShare,
      constraints: { video: { aspectRatio: 1, height: { ideal: 720 } } },
      screenshot: false,
      picture: [],
      outputAspectRatio: 1,
      inputAspectRatio: null,
      outputHeight: null,
      outputWidth: null,
      html2canvas: null
    };
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    storiesNbr: {
      type: Number,
      required: true
    }
  },
  methods: {
    async startCapture() {
      this.screenshot = false;
      if (this.supported) {
        navigator.mediaDevices.getUserMedia(this.constraints).then((stream) => {
          const { video } = this.$refs;
          video.srcObject = stream;
        });
      }
      const { default: html2canvas } = await import('html2canvas');
      this.html2canvas = html2canvas;
    },
    async takeScreenshot() {
      this.picture.length = 0;
      const {
        video, img, canvas, canvas2, overlay
      } = this.$refs;
      const ctx = canvas.getContext('2d');
      const ctx2 = canvas2.getContext('2d');
      this.crop(video, canvas);
      const outputX = (this.outputWidth - video.videoWidth) * 0.5;
      const outputY = (this.outputHeight - video.videoHeight) * 0.5;
      ctx.translate(this.outputWidth, 0);
      ctx.scale(-1, 1);
      ctx.drawImage(video, outputX, outputY);
      canvas2.width = this.outputWidth;
      canvas2.height = this.outputHeight;
      ctx2.drawImage(canvas, outputX, outputY);
      ctx2.drawImage(overlay, 0, 0, this.outputHeight, this.outputWidth);
      this.html2canvas(document.querySelector('#capture'), { backgroundColor: null }).then(textCanvas => {
        const newHeight = Math.ceil((textCanvas.height / textCanvas.width) * this.outputWidth);
        ctx2.drawImage(textCanvas, 0, this.outputHeight - newHeight, this.outputWidth, newHeight);
        img.src = canvas2.toDataURL('image/png');
        this.screenshot = true;
        this.urlToFile(img.src, 'jlc-share.png', 'image/png').then((file) => { this.picture.push(file); });
      });
      video.srcObject.getVideoTracks().forEach(track => track.stop());
    },
    urlToFile(url, filename, mimeType) {
      return (fetch(url)
        .then((res) => res.arrayBuffer())
        .then((buf) => new File([buf], filename, { type: mimeType }))
      );
    },
    crop(video, canvas) {
      this.inputAspectRatio = video.videoWidth / video.videoHeight;
      this.outputHeight = video.videoHeight;
      this.outputWidth = video.videoWidth;
      if (this.inputAspectRatio > this.outputAspectRatio) {
        this.outputHeight = video.videoWidth * this.outputAspectRatio;
      } else if (this.inputAspectRatio < this.outputAspectRatio) {
        this.outputWidth = video.videoHeight / this.outputAspectRatio;
      }
      canvas.width = this.outputWidth;
      canvas.height = this.outputHeight;
    },
    share() {
      if (this.shareSupported) {
        if (navigator.canShare({ files: this.picture })) {
          navigator.share({
          files: this.picture,
          text: this.$i18n.t('share.sharing_text')
            }).then(() => console.log('Successful share'))
          .catch((error) => console.log('Error sharing', error));
        } else {
          this.shareSupported = false;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.share {
    &-content {
        @include padding(28px null null);
    }
    &-title {
        @include margin(null null 5px);
    }
    &-picture {
       @include margin(null -20px);
       @include aspect-ratio(1,1);
       video,
       img,
       canvas {
        @include size(100%);
        object-fit: cover;
        @include position(absolute, 0 null null 0);
       }
       video {
          transform: scaleX(-1);
       }
       img.logo {
           @include size(47px);
           @include position(absolute, 10px 20px null auto);
       }
    }
    &-user {
        width: 100%;
        @include padding(12px 20px);
        @include position(absolute, null null 0 0);
        // backdrop-filter: blur(20px);
        background: linear-gradient(0deg, rgba(58,57,53,.8) 48%, rgba(58,57,53,.7) 62%, rgba(58,57,53,.6) 100%);
    }
    &-info {
        display: flex;
        flex-flow: row wrap;
        li {
            @include font('tertiary', 'regular');
            color: $secondary;
            font-size: rem(36px);
            line-height: 1.1;
            @include mq($until: 330px) {
                font-size: rem(32px);
            }
            + li {
                @include margin(null null null 25px);
            }
            .lighten {
                opacity: .5;
                font-size: rem(28px);
                @include mq($until: 330px) {
                    font-size: rem(24px);
                }
            }
        }
        .label {
            @include font('primary', 'bold');
            display: block;
            max-width: 80px;
            color: rgba($tertiary, .5);
            font-size: rem(7.5px);
            line-height: 1.333;
        }
    }
    .btn-round {
        display: block;
        @include margin(null auto);
        background-color: $tertiary;
        border-radius: 50%;
        .svg {
            fill: $primary;
        }
        &:focus,
        &:active {
          outline: none;
        }
        &[disabled] {
          cursor: auto;
          opacity: .3;
        }
        &.large {
            @include size(77px);
        }
    }
    .btn {
        @include margin(20px null null);
    }
}
</style>
